export default __webpack_public_path__ + "static/media/pw.7c450528.svg";